// extracted by mini-css-extract-plugin
export default {"container":"xI-z","topReviewHeading":"yI-z","criticalReview":"zI-z","favorableReview":"AI-z","vsSeparator":"BI-z"};